export default "__VITE_ASSET__EvsEJ$5p6pJFFzCELLx1tA__ 480w, __VITE_ASSET__L8Fs_TmwgLeEJ8oqil9r1g__ 745w";